// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import { IButtonProps, IButtonStyles, ITheme, DefaultButton, useTheme } from '@fluentui/react';

export const LargeRoundedButton = (props: IButtonProps): JSX.Element => {
  const theme = useTheme();
  return <DefaultButton {...props} styles={largeRoundedButtonStyles(theme)} />;
};

const largeRoundedButtonStyles = (theme: ITheme): IButtonStyles => ({
  root: {
    borderRadius: '0.5rem',
    height: '100%',
    padding: '0.875rem',
    borderColor: theme.palette.neutralQuaternaryAlt,
    width: '8rem'
  },
  flexContainer: {
    flexDirection: 'column',
    gap: '0.5rem'
  },
  icon: {
    color: theme.palette.themePrimary
  },
  textContainer: {
    fontWeight: '600',
    fontSize: '0.875rem'
  }
});
